import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewDicose = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'dicose',
        name: 'Dicose',
        component: ViewDicose,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
